import { c as _c } from "react/compiler-runtime";
import type { ReactNode, ElementType } from 'react';
interface Props {
  children?: ReactNode;
  component?: ElementType;
}
export default function FooterItem(t0) {
  const $ = _c(3);
  const {
    children,
    component: t1
  } = t0;
  const Component = t1 === undefined ? "div" : t1;
  let t2;
  if ($[0] !== Component || $[1] !== children) {
    t2 = <Component>{children}</Component>;
    $[0] = Component;
    $[1] = children;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}